import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { global } from "../../environments/global";
import { ModalController, IonicApp, App } from "ionic-angular/index";

/*
  Generated class for the MyAlertProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MyAlertProvider {
  constructor(public http: HttpClient, private modalCtrl: ModalController) {
    console.log("Hello MyAlertProvider Provider");
  }

  error_code: any;

  showAlert(alert: AlertObj) {
    if (alert.title == "default") alert.title = "获取数据失败";
    if (alert.message == "default") alert.message = global.bot_name + "遇到点难题，我们正在抢修...";
    this.showModal(alert);
  }

  showNormalDanger() {
    //象征性的通知一下
    let alertObj = {
      type: "error",
      title: "获取数据失败",
      message: global.bot_name + "遇到点难题，我们正在抢修...",
      success: {
        text: "知道了"
      }
    };

    this.showModal(alertObj);
  }

  alertCancel(alertObj) {
    if (alertObj.fail && alertObj.fail.callback) alertObj.fail.callback();
    this.error_code = 0;
  }

  alertSuccess(alertObj) {
    if (alertObj.success && alertObj.success.callback) alertObj.success.callback();
    this.error_code = 0;

  }

  showErrorAlert(res) {
    let alertObj = {
      type: "error",
      title: "错误",
      message: "",
      success: {
        text: "知道了"
      }
    };
    this.error_code = res["err_code"];
    this.showModal(alertObj);
  }

  modal;

  showModal(alertObj) {
    console.log("1");

    this.modal = undefined;
    if (!this.modal || (this.modal.overlay && this.modal.overlay._state == 4)) {
      this.modal = this.modalCtrl.create("MyAlertPage", {
        alertObj: alertObj,
        errorCode: this.error_code
      });
      this.modal.onWillDismiss((is_success) => {
        if (is_success) {
          this.alertSuccess(alertObj);
        }
        else {
          this.alertCancel(alertObj);
        }
      });
      this.modal.present();
    } else {
      this.alertSuccess(alertObj);

    }

  }
}

interface AlertObj {
  type: string;
  title?: string;
  message?: string;
  fail?: AlertBtn;
  success?: AlertBtn;
}

interface AlertBtn {
  text: string;
  callback?: any;
}



// WEBPACK FOOTER //
// ./src/providers/my-alert/my-alert.ts